export const projetosEndpoint = {
    // Projetos
    projeto: {
        listar: `/api/v1/projetos`,
        listarResumidos: `/api/v1/projetos/resumido`,
        criar: `/api/v1/projetos`,
        obterCabecalho: (id) => `/api/v1/projetos/${id}/cabecalho`,
        obterDados: (id) => `/api/v1/projetos/${id}/dados`,
        atualizar: (id) => `/api/v1/projetos/${id}`,
        exportar: `/api/v1/projetos/exportar`,

        // Relatórios
        gerarRelatorio: (id) => `/api/v1/projetos/${id}/exportar-pdf`,
        listarRelatorios: (id) => `api/v1/projetos/exportar-pdf/${id}/meus-relatorios`,
        listarTodosRelatorios: `api/v1/projetos/exportar-pdf/meus-relatorios`,
        baixarRelatorio: (nome_arquivo) => `/api/v1/projetos/exportar-pdf/baixar/${nome_arquivo}`,
        cancelarRelatorio: (exportacao_id) => `/api/v1/projetos/exportar-pdf/${exportacao_id}`,

        // Status
        atualizarStatus: (id) => `/api/v1/projetos/${id}/status`,
    },

    // Contas Bancárias
    contasBancarias: {
        listarTodas: `/api/v1/projetos/contabancaria`,
        listar: (id) => `/api/v1/projetos/${id}/contabancaria`,
        criar: (projeto_id) => `/api/v1/projetos/${projeto_id}/contabancaria`,
        atualizar: (id) => `/api/v1/projetos/contabancaria/${id}`,
        apagar: (id) => `/api/v1/projetos/contabancaria/${id}`,
    },

    // Rendimentos de Conta Bancária
    rendimentosContaBancaria: {
        listar: (projeto_id) => `/api/v1/projetos/${projeto_id}/rendimentos-conta-bancaria`,
        listarResumida: (projeto_id) => `/api/v1/projetos/${projeto_id}/rendimentos-conta-bancaria/resumido`,
        criar: (projeto_id) => `/api/v1/projetos/${projeto_id}/rendimentos-conta-bancaria`,
        obter: (id) => `/api/v1/projetos/rendimentos-conta-bancaria/${id}`,
        atualizar: (id) => `/api/v1/projetos/rendimentos-conta-bancaria/${id}`,
        apagar: (id) => `/api/v1/projetos/rendimentos-conta-bancaria/${id}`,
        obterComprovante: (id) => `/api/v1/projetos/rendimentos-conta-bancaria/${id}/comprovante`,
    },

    // Instituições Apoiadas
    instituicaoApoiada: {
        listar: `/api/v1/projetos/instituicaoapoiada`,
        criar: `/api/v1/projetos/instituicaoapoiada`,
        atualizar: (id) => `/api/v1/projetos/instituicaoapoiada/${id}`,
        apagar: (id) => `/api/v1/projetos/instituicaoapoiada/${id}`,
        adicionarPessoaJuridica: (id) => `/api/v1/projetos/instituicaoapoiada/${id}/pessoajuridica`,
        removerPessoaJuridica: (id) => `/api/v1/projetos/instituicaoapoiada/pessoajuridica/${id}`,
    },

    // Instrumentos Jurídicos
    instrumentoJuridico: {
        listar: `/api/v1/projetos/instrumentos-juridicos`,
        criar: `/api/v1/projetos/instrumentos-juridicos`,
        obter: (id) => `/api/v1/projetos/instrumentos-juridicos/${id}`,
        atualizar: (id) => `/api/v1/projetos/instrumentos-juridicos/${id}`,
        apagar: (id) => `/api/v1/projetos/instrumentos-juridicos/${id}`,
        obterDocumento: (id) => `/api/v1/projetos/instrumentos-juridicos/${id}/documento`,
        // Anexos
        listarAnexos: (id) => `/api/v1/projetos/instrumentos-juridicos/${id}/anexos`,
        adicionarAnexo: `/api/v1/projetos/instrumentos-juridicos/anexos`,
        atualizarAnexo: (id) => `/api/v1/projetos/instrumentos-juridicos/anexos/${id}`,
        apagarAnexo: (id) => `/api/v1/projetos/instrumentos-juridicos/anexos/${id}`,
        baixarAnexo: (id) => `/api/v1/projetos/instrumentos-juridicos/anexos/${id}/documento`,
    },

    // Aditivos
    aditivos: {
        listar: (id) => `/api/v1/projetos/${id}/aditivos`,
        criar: (id) => `/api/v1/projetos/${id}/aditivos`,
        obterDocumento: (id) => `api/v1/projetos/aditivos/${id}/documento`,
        substituirDocumento: (id) => `/api/v1/projetos/aditivos/${id}/documento`,
        atualizar: (id) => `/api/v1/projetos/aditivos/${id}`,
        listarHistoricoAlteracoes: (id, page = 1, size = 10) => `/api/v1/projetos/aditivos/${id}/historico-alteracoes?page=${page}&size=${size}`,
    },

    statusHistorico: {
        listar: (id) => `/api/v1/projetos/${id}/status`,
    },

    // Histórico de alterações dos dados do projeto
    historicoAlteracoes: {
        listar: (id, page = 1, size = 50) => `/api/v1/projetos/${id}/historico-alteracoes?page=${page}&size=${size}`,
    },

    // Rubricas
    rubricas: {
        listar: (id) => `/api/v1/projetos/${id}/rubricas`,
        listarCabecalho: (id) => `/api/v1/projetos/${id}/rubricas/cabecalho`,
        listarRetiradaRendimentos: (id) => `/api/v1/projetos/${id}/rubricas/retirada-rendimentos`,
        criar: (id) => `/api/v1/projetos/${id}/rubricas`,
        atualizar: (id) => `/api/v1/projetos/rubricas/${id}`,
        cancelar: (id) => `/api/v1/projetos/rubricas/${id}/cancelar`,
    },

    // Detalhamento de Rubricas
    rubricasDetalhamento: {
        listar: (id, rubricasfinanceira_id) => `/api/v1/projetos/${id}/rubricas/${rubricasfinanceira_id}/detalhes`,
        listarPorCodigo: (id, codigo) => `/api/v1/projetos/${id}/rubricas-codigo/${codigo}/detalhes`,
        listarPorTipoSolicitacao: (id, tiposolicitacao_id) => `/api/v1/projetos/${id}/tipo-solicitacoes-projetos/${tiposolicitacao_id}/rubricas`,
        criar: `/api/v1/projetos/rubricas/detalhes`,
        obter: (id) => `/api/v1/projetos/rubricas/detalhes/${id}`,
        atualizar: (id) => `/api/v1/projetos/rubricas/detalhes/${id}`,
        cancelar: (id) => `/api/v1/projetos/rubricas/detalhes/${id}/cancelar`,
        listarEntidadesRelacionadas: (id, page = 1, size = 50) => `/api/v1/projetos/rubricas/detalhes/${id}/entidades-relacionadas?page=${page}&size=${size}`,
    },

    // Metas
    metas: {
        listar: (id) => `/api/v1/projetos/${id}/metas`,
        criar: (id) => `/api/v1/projetos/${id}/metas`,
        atualizar: (id) => `/api/v1/projetos/metas/${id}`,
        apagar: (id) => `/api/v1/projetos/metas/${id}`,
        listarMetasRelacionadas: (meta_id, page = 1, size = 50) => `/api/v1/projetos/metas/${meta_id}/solicitacoes?page=${page}&size=${size}`,
        exportarGastos: (id) => `/api/v1/projetos/${id}/metas/gastos`,
        exportarSolicitacoes: (id) => `/api/v1/projetos/${id}/metas/solicitacoes/exportar`,
    },

    // Desembolsos
    desembolsos: {
        listarTodos: `/api/v1/projetos/desembolsos`,
        listar: (id) => `/api/v1/projetos/${id}/desembolsos`,
        listarNaoConciliados: (id) => `/api/v1/projetos/${id}/desembolsos/nao-conciliados`,
        criar: (id) => `/api/v1/projetos/${id}/desembolsos`,
        atualizar: (id) => `/api/v1/projetos/desembolsos/${id}`,
        apagar: (id) => `/api/v1/projetos/desembolsos/${id}`,
        quitar: (id) => `/api/v1/projetos/desembolsos/${id}/quitacao`,
        desquitar: (id) => `/api/v1/projetos/desembolsos/${id}/desquitar`,
        // Notas Fiscais
        adicionarNotaFiscal: (id) => `/api/v1/projetos/desembolsos/${id}/nota-fiscal`,
        obterNotaFiscal: (id) => `api/v1/projetos/desembolsos/${id}/nota-fiscal`,
        apagarNotaFiscal: (id) => `/api/v1/projetos/desembolsos/${id}/nota-fiscal`,
    },

    // Membros
    membros: {
        listar: (id) => `/api/v1/projetos/${id}/membros`,
        listarPendentes: `/api/v1/projetos/membros/pendentes`,
        obterMembro: (id) => `/api/v1/projetos/membros/${id}`,
        listarComParcelasAPagar: (id) => `/api/v1/projetos/${id}/membros/pagamento`,
        listarComBolsasValidas: (id) => `/api/v1/projetos/${id}/membros/parcelas-a-solicitar`,
        adicionar: (id) => `/api/v1/projetos/${id}/membros`,
        ativar: (id) => `/api/v1/projetos/membros/${id}/aprovado`,
        cancelar: (id) => `/api/v1/projetos/membros/${id}/cancelado`,
        exportar: (id) => `/api/v1/projetos/${id}/membros/exportar-planilha`,

        // Subcoordenador
        adicionarSubcoordenador: (id) => `/api/v1/projetos/${id}/membros/subcoordenador`,

        // Alterar Coordenador
        alterarCoordenador: (id) => `/api/v1/projetos/${id}/membros/alterar-coordenador`,

        // Anexos
        listarAnexos: (id) => `/api/v1/projetos/membros/${id}/anexos`,
        baixarAnexo: (id) => `/api/v1/projetos/membros/anexos/${id}/documento`,

        // Bolsas
        listarBolsasRecebidas: (id) => `/api/v1/projetos/membros/${id}/bolsas-recebidas`,

        // Contratos a vencer
        contratosAVencer: `/api/v1/projetos/membros/contratos-a-vencer`,
    },

    // Solicitações
    solicitacoes: {
        listarTodas: `/api/v1/projetos/solicitacoes`,
        listarAjuste: `/api/v1/projetos/solicitacoes/ajuste`,
        listar: (id) => `/api/v1/projetos/${id}/solicitacoes`,
        listarRascunhos: (id) => `/api/v1/projetos/${id}/solicitacoes/rascunho`,
        obter: (id) => `/api/v1/projetos/solicitacoes/${id}`,
        removerRascunho: (id) => `/api/v1/projetos/solicitacoes/${id}/rascunho`,
        exportar: (id) => `/api/v1/projetos/${id}/solicitacoes/exportar`,
        cancelar: (id) => `/api/v1/projetos/solicitacoes/${id}/cancelar`,

        // Status
        atualizarStatus: (id) => `/api/v1/projetos/solicitacoes/${id}/status`,

        // Pagamentos
        listarPagamentos: (id) => `/api/v1/projetos/solicitacoes/${id}/pagamentos`,

        // Downloads
        baixarAnexo: (id) => `/api/v1/projetos/solicitacoes/${id}/anexo`,
        baixarBoleto: (id) => `/api/v1/projetos/solicitacoes/${id}/boleto`,
        baixarDeclaracaoINSS: (id) => `/api/v1/projetos/solicitacoes/${id}/declaracao-inss`,

        // Tipos de Solicitação disponiveis
        obterTiposSolicitacaoDisponiveis: (id) => `/api/v1/projetos/${id}/tipos-solicitacoes`,

        // Detalhe de Rúbrica
        atualizarDetalheRubrica: (id) => `/api/v1/projetos/solicitacoes/${id}/detalhe-rubrica`,
        listarHistoricoDetalheRubrica: (id) => `/api/v1/projetos/solicitacoes/${id}/detalhe-rubrica/historico`,

        // Meta de Solicitação
        atualizarMeta: (id) => `/api/v1/projetos/solicitacoes/${id}/metas`,

        // Subrubricas de Solicitação
        atualizarSubrubrica: (id) => `/api/v1/projetos/solicitacoes/${id}/subrubricas`,
    },

    // Solicitações - Material
    solicitacoesMaterial: {
        criar: (id) => `/api/v1/projetos/${id}/solicitacoes/material`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/material`,
    },

    // Solicitações - Serviço
    solicitacoesServico: {
        criarPF: (id) => `/api/v1/projetos/${id}/solicitacoes/servico-pessoa-fisica`,
        criarPJ: (id) => `/api/v1/projetos/${id}/solicitacoes/servico-pessoa-juridica`,
        atualizarPF: (id) => `/api/v1/projetos/solicitacoes/${id}/servico-pessoa-fisica`,
        atualizarPJ: (id) => `/api/v1/projetos/solicitacoes/${id}/servico-pessoa-juridica`,
    },

    // Solicitações - Auxílio
    solicitacoesAuxilio: {
        criar: (id) => `/api/v1/projetos/${id}/solicitacoes/auxilio-financeiro`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/auxilio-financeiro`,
    },

    // Solicitações - Ajuda de Custo Estudantes
    solicitacoesAjudaCustoEstudantes: {
        criar: (id) => `/api/v1/projetos/${id}/solicitacoes/ajuda-de-custo-estudantes`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/ajuda-de-custo-estudantes`,
    },

    // Solicitações - Ajuda de Custo Viagem
    solicitacoesAjudaCustoViagem: {
        criar: (id) => `/api/v1/projetos/${id}/solicitacoes/ajuda-de-custo-estudantes-viagem`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/ajuda-de-custo-estudantes-viagem`,
    },

    // Solicitações - Passagens
    solicitacoesPassagens: {
        criar: (id) => `/api/v1/projetos/${id}/solicitacoes/passagem`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/passagem`,
    },

    // Solicitações - Hospedagens
    solicitacoesHospedagens: {
        criar: (id) => `/api/v1/projetos/${id}/solicitacoes/hospedagem`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/hospedagem`,
    },

    // Solicitações - Diárias
    solicitacoesDiarias: {
        criar: (id) => `/api/v1/projetos/${id}/solicitacoes/diaria`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/diaria`,
    },

    // Solicitações - Pagamento de Bolsa
    solicitacoesPagamentoBolsa: {
        criar: (id) => `/api/v1/projetos/${id}/solicitacoes/pagamento-bolsa`,
        criarLote: (id) => `/api/v1/projetos/${id}/solicitacoes/pagamento-bolsa-lote`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/pagamento-bolsa`,
    },

    // Solicitações - Pagamento de Bolsa Eventual
    solicitacoesPagamentoBolsaEventual: {
        criar: (id) => `/api/v1/projetos/${id}/solicitacoes/pagamento-bolsa-eventual`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/pagamento-bolsa-eventual`,
        baixarAnexo: (id) => `/api/v1/projetos/solicitacoes/${id}/anexo-complementar`,
    },

    // Solicitações - Pagamento de Serviço
    solicitacoesPagamentoServico: {
        criarPF: (id) => `/api/v1/projetos/${id}/solicitacoes/pagamento-servico-pessoa-fisica`,
        criarPJ: (id) => `/api/v1/projetos/${id}/solicitacoes/pagamento-servico-pessoa-juridica`,
        atualizarPF: (id) => `/api/v1/projetos/solicitacoes/${id}/pagamento-servico-pessoa-fisica`,
        atualizarPJ: (id) => `/api/v1/projetos/solicitacoes/${id}/pagamento-servico-pessoa-juridica`,
        cadastrarStatus: (id) => `/api/v1/projetos/solicitacoes/${id}/pagamento-servico/status`,
    },

    // Solicitações - Pagamento de Material
    solicitacoesPagamentoMaterial: {
        criar: (id) => `/api/v1/projetos/${id}/solicitacoes/pagamento-material`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/pagamento-material`,
    },

    solicitacoesPagamentoPremiacoes: {
        criar: (id) => `/api/v1/projetos/${id}/solicitacoes/premiacao`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/premiacao`,
    },

    // Solicitações - Reembolso
    solicitacoesReembolso: {
        criar: (id) => `/api/v1/projetos/${id}/solicitacoes/reembolso`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/reembolso`,
    },

    // Solicitações - Recarga de Cartão
    solicitacoesRecargaCartao: {
        criar: (id) => `/api/v1/projetos/${id}/solicitacoes/recarga-cartao`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/recarga-cartao`,
        avaliar: (id) => `/api/v1/projetos/solicitacoes/${id}/recarga-cartao/avaliacao`,
    },

    // Solicitações - Cadastro de Pessoa Jurídica
    solicitacoesCadastroPessoaJuridica: {
        criar: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/cadastro-pessoa-juridica`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/cadastro-pessoa-juridica`,
    },

    // Solicitações - Cadastro de Pessoa Física
    solicitacoesCadastroPessoaFisica: {
        criar: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/cadastro-pessoa-fisica`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/cadastro-pessoa-fisica`,
    },

    // Solicitações - Cancelamento de Contrato
    solicitacoesCancelamentoContrato: {
        criar: (id) => `/api/v1/projetos/${id}/solicitacoes/cancelamento-contrato`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/cancelamento-contrato`,
    },

    // Solicitações - Locação de Veículos
    solicitacoesLocacao: {
        criar: (id) => `/api/v1/projetos/${id}/solicitacoes/locacao-veiculo`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/locacao-veiculo`,
    },

    // Solicitações - DOA (Declaração de Ônus e Aprovação)
    solicitacoesDoa: {
        listar: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/doa`,
        criar: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/doa`,
        saldoDoa: (projeto_id) => `/api/v1/projetos/${projeto_id}/saldo-doa`,
    },

    solicitacoesDevolucaoOrgaoFinanciador: {
        criar: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/devolucao-financiador`,
        atualizar: (solicitacao_devolucao_id) => `/api/v1/projetos/solicitacoes/${solicitacao_devolucao_id}/devolucao-financiador`,
    },

    // Solicitações - Empréstimo
    solicitacoesEmprestimo: {
        listar: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/emprestimo`,
        criar: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/emprestimo`,
    },

    solicitacoesRepasseApoiada: {
        criar: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/repasse-apoiada`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/repasse-apoiada`,
    },

    // Solicitações - Retirada de Rendimentos
    solicitacoesRetiradaRendimentos: {
        criar: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/retirada-rendimentos`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/retirada-rendimentos`,
    },

    // Solicitações - Suprimento de Fundos
    solicitacoesSuprimentoFundos: {
        criar: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/suprimento-fundos`,
        atualizar: (id) => `/api/v1/projetos/solicitacoes/${id}/suprimento-fundos`,
    },

    // Solicitações - Pagamento de Empréstimo
    solicitacoesPagamentoEmprestimo: {
        listarPorSolicitacaoEmprestimo: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/pagamento-emprestimo`,
        criar: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/pagamento-emprestimo`,
    },

    // Solicitações - Transferência Bancária entre Contas
    solicitacoesTransferenciaBancariaEntreContas: {
        listarPorTransferenciaBancariaEntreContas: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/transferencia-bancaria`,
        criar: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/transferencia-bancaria`,
    },

    solicitacoesReceitaPorEncerramento: {
        listarPorReceitaPorEncerramento: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/receita-encerramento`,
        criar: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/receita-encerramento`,
    },

    solicitacoesClt: {
        listar: (projeto_id, query = '') =>
            `/api/v1/projetos/${projeto_id}/solicitacoes/clt${query ? `${query}` : ''}`,
    },

    solicitacoesEncargo: {
        criar: (id) => `/api/v1/projetos/solicitacoes/${id}/encargo`,
        apagar: (id) => `/api/v1/projetos/solicitacoes/encargo/${id}`,
    },

    solicitacoesAuxilioFinanceiroLote: {
        criar: () => `/api/v1/projetos/solicitacoes/auxilio-financeiro-lote`,
    },

    // Relatórios de Solicitacao
    relatoriosSolicitacao: {
        listarTodos: `/api/v1/projetos/solicitacoes/relatorio`,
        listarPendentes: `/api/v1/projetos/solicitacoes/relatorio/pendentes`,
        listar: (projeto_id) => `/api/v1/projetos/${projeto_id}/solicitacoes/relatorio`,
        criar: (solicitacao_id) => `/api/v1/projetos/solicitacoes/${solicitacao_id}/relatorio`,
        atualizar: (relatorio_id) => `/api/v1/projetos/solicitacoes/relatorio/${relatorio_id}`,
        obterDocumento: (relatorio_id) => `/api/v1/projetos/solicitacoes/relatorio/${relatorio_id}/documento`,
        atualizarStatus: (solicitacao_id) => `/api/v1/projetos/solicitacoes/${solicitacao_id}/relatorio/status`,
        obterRelatorioSolicitacao: (id) => `/api/v1/projetos/solicitacoes/relatorio/${id}`,
        remover: (relatorio_id) => `/api/v1/projetos/solicitacoes/relatorio/${relatorio_id}`,
        listarComprovantes: (relatorio_id) => `/api/v1/projetos/solicitacoes/relatorio/${relatorio_id}/comprovantes`,
        obterComprovante: (relatorio_id, documento) => `/api/v1/projetos/solicitacoes/relatorio/${relatorio_id}/comprovantes/${documento}`,
    },

    // Balancete
    balancete: {
        obter: (projeto_id) => `/api/v1/projetos/${projeto_id}/balancete`,
        obterDetalhado: (projeto_id) => `/api/v1/projetos/${projeto_id}/balancete-detalhado`,
    },

    // Termos
    termos: {
        listarPorProjeto: (projeto_id) => `/api/v1/projetos/projetos/${projeto_id}/termos`,
    },
}